import _styled from "styled-components";
var _class, _class2, _descriptor, _descriptor2, _MapNavigationBase;
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { debounce } from "lodash-es";
import { action, computed, observable, reaction, runInAction, makeObservable } from "mobx";
import { observer } from "mobx-react";
import { createRef, Component } from "react";
import { withTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import Box from "../../../Styled/Box";
import Icon, { GLYPHS } from "../../../Styled/Icon";
import { OVERFLOW_ITEM_ID } from "../../../ViewModels/MapNavigation/MapNavigationModel";
import withControlledVisibility from "../../HOCs/withControlledVisibility";
import MapIconButton from "../../MapIconButton/MapIconButton";
import { filterViewerAndScreenSize } from "./filterViewerAndScreenSize";
import { Control, MapNavigationItem } from "./Items";
import { registerMapNavigations } from "./registerMapNavigations";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OVERFLOW_ACTION_SIZE = 42;
/**
 * TODO: fix this so that we don't need to override pointer events like this.
 * a fix would look like breaking up the top and bottom parts, so there is
 * no element "drawn/painted" between the top and bottom parts of map
 * navigation
 */
const StyledMapNavigation = styled.div.withConfig({
  displayName: "MapNavigation__StyledMapNavigation",
  componentId: "sc-coiw-0"
})(["position:absolute;right:5px;z-index:1;top:25px;@media (min-width:", "px){top:80px;bottom:50px;right:21px;}@media (max-width:", "px){& > div{flex-direction:row;}}pointer-events:none;button{pointer-events:auto;}", ""], props => props.theme.sm, props => props.theme.mobile, p => p.trainerBarVisible && "\n    top: ".concat(Number(p.theme.trainerHeight) + Number(p.theme.mapNavigationTop), "px;\n  "));
const ControlWrapper = styled(Box).withConfig({
  displayName: "MapNavigation__ControlWrapper",
  componentId: "sc-coiw-1"
})(["@media (min-width:", "px){& >:first-child{margin-top:0 !important;padding-top:0 !important;}}"], props => props.theme.sm);
var _StyledControlWrapper = styled(ControlWrapper).withConfig({
  displayName: "MapNavigation___StyledControlWrapper",
  componentId: "sc-coiw-2"
})(["", ""], p => p.$_css);
var Orientation = /*#__PURE__*/function (Orientation) {
  Orientation[Orientation["HORIZONTAL"] = 0] = "HORIZONTAL";
  Orientation[Orientation["VERTICAL"] = 1] = "VERTICAL";
  return Orientation;
}(Orientation || {});
let MapNavigationBase = observer(_class = (_class2 = (_MapNavigationBase = class MapNavigationBase extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "navigationRef", /*#__PURE__*/createRef());
    _defineProperty(this, "resizeListener", void 0);
    _defineProperty(this, "viewState", void 0);
    _defineProperty(this, "itemSizeInBar", void 0);
    _initializerDefineProperty(this, "model", _descriptor, this);
    _initializerDefineProperty(this, "overflows", _descriptor2, this);
    _defineProperty(this, "viewerModeReactionDisposer", void 0);
    makeObservable(this);
    registerMapNavigations(props.viewState);
    this.viewState = props.viewState;
    this.model = props.viewState.terria.mapNavigationModel;
    this.resizeListener = debounce(() => this.updateNavigation(), 250);
    this.itemSizeInBar = new Map();
    this.computeSizes();
    this.overflows = runInAction(() => this.model.visibleItems.some(item => item.controller.collapsed));
    this.viewerModeReactionDisposer = reaction(() => this.viewState.terria.currentViewer, () => this.updateNavigation(), {
      equals: (a, b) => {
        return a === b;
      }
    });
  }
  componentDidMount() {
    this.computeSizes();
    this.updateNavigation();
    window.addEventListener("resize", this.resizeListener, false);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeListener);
    if (this.viewerModeReactionDisposer) {
      this.viewerModeReactionDisposer();
    }
  }
  get orientation() {
    return this.viewState.useSmallScreenInterface ? Orientation.HORIZONTAL : Orientation.VERTICAL;
  }
  computeSizes(items) {
    (items !== null && items !== void 0 ? items : this.model.visibleItems).forEach(item => {
      if (this.orientation === Orientation.VERTICAL) {
        if (item.controller.height && item.controller.height > 0) {
          this.itemSizeInBar.set(item.id, item.controller.height || 42);
        }
      } else {
        if (item.controller.width && item.controller.width > 0) {
          this.itemSizeInBar.set(item.id, item.controller.width || 42);
        }
      }
    });
  }

  /**
   * Check if we need to collapse navigation items and determine which one need to be collapsed.
   */
  updateNavigation() {
    var _this$navigationRef$c, _this$navigationRef$c2;
    if (!this.navigationRef.current) {
      // navigation bar has not been rendered yet so there is nothing to update.
      return;
    }
    if (this.computeSizes.length !== this.model.visibleItems.length) {
      this.computeSizes();
    }
    const itemsToShow = this.model.visibleItems.filter(item => filterViewerAndScreenSize(item, this.viewState));
    // items we have to show in the navigation bar
    const pinnedItems = this.model.pinnedItems.filter(item => filterViewerAndScreenSize(item, this.viewState));
    // items that are possible to be collapsed
    const possibleToCollapse = itemsToShow.filter(item => !pinnedItems.some(pinnedItem => pinnedItem.id === item.id)).reverse();

    // Ensure we are not showing more composites than we have height for
    let overflows = false;
    let maxVisible = itemsToShow.length;
    let size = 0;
    if (this.overflows) {
      size += OVERFLOW_ACTION_SIZE;
    }
    const limit = this.orientation === Orientation.VERTICAL ? this.navigationRef.current.clientHeight : (_this$navigationRef$c = this.navigationRef.current.parentElement) !== null && _this$navigationRef$c !== void 0 && _this$navigationRef$c.parentElement ? ((_this$navigationRef$c2 = this.navigationRef.current.parentElement) === null || _this$navigationRef$c2 === void 0 || (_this$navigationRef$c2 = _this$navigationRef$c2.parentElement) === null || _this$navigationRef$c2 === void 0 ? void 0 : _this$navigationRef$c2.clientWidth) - 100 : this.navigationRef.current.clientWidth;
    for (let i = 0; i < itemsToShow.length; i++) {
      size += this.itemSizeInBar.get(itemsToShow[i].id) || 0;
      if (size <= limit) {
        maxVisible = i + 1;
      }
    }
    if (pinnedItems.length > maxVisible) {
      possibleToCollapse.forEach(item => {
        this.model.setCollapsed(item.id, true);
      });
      //there is nothing else we can do, we have to show the rest of items as it is.
      return;
    }
    overflows = itemsToShow.length > maxVisible;
    const itemsToCollapseId = [];
    const activeCollapsible = [];
    if (overflows) {
      if (!this.overflows) {
        // overflow is not currently visible so add its height here
        size += OVERFLOW_ACTION_SIZE;
        this.overflows = true;
      }
      maxVisible = maxVisible - pinnedItems.length;
      // first try to collapse inactive items and then active ones if needed
      for (let i = 0; i < possibleToCollapse.length; i++) {
        const item = possibleToCollapse[i];
        if (item.controller.active) {
          activeCollapsible.push(item.id);
          continue;
        }
        itemsToCollapseId.push(item.id);
        size -= this.itemSizeInBar.get(item.id) || 0;
        if (size <= limit) {
          break;
        }
      }
      if (size > limit) {
        for (let i = 0; i < activeCollapsible.length; i++) {
          const itemId = activeCollapsible[i];
          itemsToCollapseId.push(itemId);
          size -= this.itemSizeInBar.get(itemId) || 0;
          if (size <= limit) {
            break;
          }
        }
      }
    } else {
      this.overflows = false;
    }
    this.model.visibleItems.forEach(item => {
      if (itemsToCollapseId.includes(item.id)) {
        this.model.setCollapsed(item.id, true);
      } else {
        this.model.setCollapsed(item.id, false);
      }
    });
  }
  render() {
    var _bottomItems;
    const {
      viewState,
      t
    } = this.props;
    const terria = viewState.terria;
    let items = terria.mapNavigationModel.visibleItems.filter(item => !item.controller.collapsed && filterViewerAndScreenSize(item, this.viewState));
    let bottomItems;
    if (!this.overflows && this.orientation !== Orientation.HORIZONTAL) {
      bottomItems = items.filter(item => item.location === "BOTTOM");
      items = items.filter(item => item.location === "TOP");
    }
    return /*#__PURE__*/_jsx(StyledMapNavigation, {
      trainerBarVisible: viewState.trainerBarVisible,
      children: /*#__PURE__*/_jsxs(Box, {
        centered: true,
        column: true,
        justifySpaceBetween: true,
        fullHeight: true,
        alignItemsFlexEnd: true,
        ref: this.navigationRef,
        children: [/*#__PURE__*/_jsxs(_StyledControlWrapper, {
          column: this.orientation === Orientation.VERTICAL,
          $_css: this.orientation === Orientation.HORIZONTAL && "margin-bottom: 5px;\n                flex-wrap: wrap;",
          children: [items.map(item => {
            // Do not expand in place for horizontal orientation
            // as it results in buttons overlapping and hiding neighboring buttons.
            return /*#__PURE__*/_jsx(MapNavigationItem, {
              expandInPlace: this.orientation !== Orientation.HORIZONTAL,
              item: item,
              terria: terria
            }, item.id);
          }), this.overflows && /*#__PURE__*/_jsx(Control, {
            children: /*#__PURE__*/_jsx(MapIconButton, {
              expandInPlace: true,
              iconElement: () => /*#__PURE__*/_jsx(Icon, {
                glyph: GLYPHS.moreItems
              }),
              title: t("mapNavigation.additionalToolsTitle"),
              onClick: () => runInAction(() => {
                viewState.showCollapsedNavigation = true;
              }),
              children: t("mapNavigation.additionalTools")
            })
          }, OVERFLOW_ITEM_ID)]
        }), /*#__PURE__*/_jsx(ControlWrapper, {
          column: this.orientation === Orientation.VERTICAL,
          children: (_bottomItems = bottomItems) === null || _bottomItems === void 0 ? void 0 : _bottomItems.map(item => /*#__PURE__*/_jsx(MapNavigationItem, {
            item: item,
            terria: terria
          }, item.id))
        })]
      })
    });
  }
}, _defineProperty(_MapNavigationBase, "displayName", "MapNavigation"), _MapNavigationBase), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "model", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "overflows", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "orientation", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "orientation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "computeSizes", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "computeSizes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateNavigation", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "updateNavigation"), _class2.prototype), _class2)) || _class;
export const MapNavigation = withTranslation()(withTheme(withControlledVisibility(MapNavigationBase)));